//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsAdmZpusobVyrizeni.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Zp�sob vy��zen� </Description>
//    <Author>      FFIALA													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-02-08                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.11.2
//AdtGeneratorConfig:[ T:(sslszvs) GID:(Web.Dia.Ts) V1:(zp_vyriz,aktivita,dat_zmena,zmenu_prov,zp_vyriz_txt,priz_cj_only,priz_vycet,ico) V2:() K1:() K2:() ]

namespace Gordic.Adm.Dialogs {

    // AdmZpusobVyrizeni
    export function DetailAdmZpusobVyrizeniDlg(
        parentContent: GContent,
        opt: {
            /** zp_vyriz */
            zp_vyriz: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailAdmZpusobVyrizeni', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmAdmZpusobVyrizeni#",
        zp_vyriz: opt ? opt.zp_vyriz : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // AdmZpusobVyrizeni
    export function SeznamAdmZpusobVyrizeniDlg(
        parentContent: GContent,
        opt: {
            /** zp_vyriz */
            zp_vyriz: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamAdmZpusobVyrizeni', { }]

    const options = {
        ID: "AdmAdmZpusobVyrizeni#",
        zp_vyriz: opt ? opt.zp_vyriz : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
